import { render, staticRenderFns } from "./CampusTabs.vue?vue&type=template&id=a14e6c5c&"
import script from "./CampusTabs.vue?vue&type=script&lang=js&"
export * from "./CampusTabs.vue?vue&type=script&lang=js&"
import style0 from "./CampusTabs.vue?vue&type=style&index=0&id=a14e6c5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports